import { render, staticRenderFns } from "./parcel_order.vue?vue&type=template&id=6c108891&"
import script from "./parcel_order.vue?vue&type=script&lang=js&"
export * from "./parcel_order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports